import { Outlet } from "react-router-dom";
import { useFeatureBoundary } from "@/features/medical-record/hooks/useFeatureBoundary";
import { useMpiFeatureBoundary } from "@/features/mpi/hooks/useMpiFeatureBoundary";

/**
 * Route-level wrapper that runs feature boundary cleanup hooks.
 * Lives in routes/ (not shared/) so the dependency on features is allowed.
 */
const FeatureBoundaryProvider = () => {
  useFeatureBoundary();
  useMpiFeatureBoundary();
  return <Outlet />;
};

export default FeatureBoundaryProvider;
